<template>
  <v-card>
    <!-- The title of the list -->
    <v-card-list-title :color="titleColor" ref="title">
      <template #title>
        <!-- A slot to change the style of the title -->
        <slot name="title">{{title}}</slot>
      </template>
    </v-card-list-title>
    <!-- The body of the component -->
    <v-list>
      <slot />
    </v-list>
  </v-card>
</template>

<script>
import VCardListTitle from "./CardListTitle";

export default {
  components: {
    VCardListTitle
  },
  props: {
    /* The title of the component. Also you can customize it with the "title" slot. */
    title: {
      type: String
    },
    titleColor: {
      type: String,
      default: "light-blue"
    }
  }
};
</script>